"use client";
const l = (i, t) => i && t ? i.startsWith("http") || t.length < 2 ? i : i.startsWith("/") ? `${t}${i}` : `${t}/${i}` : i, e = () => ({
  dataId: "",
  sheetIndex: 0,
  title: "",
  subtitle: "",
  dimensionLabels: {},
  annotations: [],
  initialSettings: {
    primary: "",
    filters: {},
    unitsDimension: ""
  },
  unitOptions: { units: "Percent", names: {}, labels: {} },
  rules: {
    mandatoryFilterDefaults: {},
    dimensionRestrictions: {},
    dimensionFlags: {},
    singlePrimaryFilterDefaults: {}
  },
  chartOptions: {
    overrideMaxY: {},
    isStacked: !1,
    minYPercent: 100,
    horizontalBar: !1,
    disableDownloadOriginalExcel: !1
  }
}), o = (i) => {
  if (i.block?.statisticsOptions)
    return i.block.statisticsOptions;
  if (i.block?.options)
    return i.block.options;
  if (i.block?.editorOptions)
    try {
      const t = JSON.parse(
        i.block.editorOptions
      );
      if ("initialSettings" in t && "dimensionLabels" in t && "chartOptions" in t && "rules" in t && "unitOptions" in t)
        return t;
    } catch {
    }
  return e();
}, n = (i, t, r) => {
  if (i?.block?.data)
    return {
      id: i.block.id,
      parentId: t,
      data: i.block.data || [],
      options: o(i),
      type: "statistics.statistics-block",
      content: {
        title: i.block.title,
        dataDescription: i.block.dataDescription,
        dataExplanation: i.block.dataExplanation,
        description: i.block.description,
        explanation: i.block.explanation
      },
      file: {
        ...i.block.file,
        url: l(i.block.file?.url, r),
        id: i.block.file?.id
      }
    };
}, d = (i, t) => ({
  id: i.id,
  parentId: t,
  title: i?.title,
  body: i?.body,
  tooltips: i?.tooltips,
  isInfoBlock: i.isInfoBlock,
  type: "statistics.info-block",
  keyContext: `section-${t}-infoblock-${i.id}`
}), a = (i, t) => ({
  id: i.id,
  keyContext: `section-${t}-accordionsblock-${i.id}`,
  type: "statistics.accordions-block",
  accordions: i.accordions
}), c = (i, t, r) => i ? i.map((s) => s.__component === "statistics.info-block" ? d(s, t) : s.__component === "statistics.statistics-block" ? n(s, t, r) : a(s, t)).filter((s) => s) : [], b = (i, t) => {
  if (i)
    return "section" in i ? b(i.section, t) : {
      id: i?.id,
      title: i?.title,
      displayTitle: i?.displayTitle,
      ingress: i?.ingress,
      introduction: i?.introduction,
      slug: i?.slug,
      createdAt: i?.createdAt,
      updatedAt: i?.updatedAt,
      publishedAt: i?.publishedAt,
      components: c(
        i?.components,
        i?.id,
        t
      )
    };
};
export {
  a as toAccordionsBlockProps,
  d as toInfoBlockProps,
  l as toMediaUrl,
  c as toSectionComponentsProps,
  b as toSectionProps,
  n as toStatsBlockProps
};
//# sourceMappingURL=index.es7.js.map
